// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1ef2eae7","239":"6d61f141","453":"a2181995","455":"18c6f2c9"}[chunkId] + ".chunk.js";
};